import { validate } from "uuid";

export const isValidUUID = (value?: string | null): value is string =>
  !!value && validate(value);
